import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Nav } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const SettingMenu = () => {
  return (
    <Nav.Item as="li">
      <Nav.Link as={Link} to="#">
        <FontAwesomeIcon icon="cog" transform="shrink-7" className="fs-4" />
      </Nav.Link>
    </Nav.Item>
  );
};

export default SettingMenu;
